// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-alert {
  z-index: 2000;
  left: 0;
  top: 0;
}

.check-icon {
  font-size: 5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Shared/SuccessAlert/SuccessAlert.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,OAAA;EACA,MAAA;AACJ;;AAEA;EACI,eAAA;AACJ","sourcesContent":[".success-alert {\n    z-index: 2000;\n    left: 0;\n    top: 0;\n}\n\n.check-icon {\n    font-size: 5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
